module.exports = __webpack_public_path__ + "media/images/green-upward-arrow-b48dbd6cb7c6af10c572250914c9c59a.png";